package streetlight.web.ui

import koala.dom.AppFacade
import koala.model.GeoCamera
import koala.model.Portal
import streetlight.web.io.ApiClient
import streetlight.web.model.MarkerMap
import streetlight.web.model.RouteDock
import streetlight.web.model.Toaster
import streetlight.web.model.SessionClient

val AppFacade.api get() = app.get<ApiClient>()
val AppFacade.portal get() = app.get<Portal>()
val AppFacade.toaster get() = app.get<Toaster>()
val AppFacade.session get() = app.get<SessionClient>()
val AppFacade.markerMap get() = app.get<MarkerMap>()
val AppFacade.geoCamera get() = app.get<GeoCamera>()
val AppFacade.dock get() = app.get<RouteDock>()
